export interface ManifestObject {
    id: string,
    src: string,
    option?: any
}
export class ManifestLoader {
    manifest: object;
    timeout: number = 1000000;
    constructor(manifest?: object) {
        this.manifest = manifest;
    }

    setManifest = (manifest: object) => {
        this.manifest = manifest;
    }

    load = (): Promise<createjs.ManifestLoader> => {
        const loadFunc = new Promise((resolve, reject) => {
            const loader = new createjs.LoadQueue(false);
            new createjs.LoadItem().set({
                manifest: this.manifest,
            })
            loader.installPlugin(createjs.Sound);
            loader.setMaxConnections(6)
            loader.on("fileload", loadManifestLoad, null, false);
            loader.on("complete", loadManifestComp, null, false);
            loader.on("canceled", () => { }, null, false);
            loader.on("error", loadManifestError, null, false);
            // console.log(this.manifest)
            loader.loadManifest(this.manifest);

            function loadManifestLoad(evt) {
                // console.log(evt.item);
                if (evt.item.type === "sound") {
                    // console.log(evt)
                    // createjs.Sound.registerSound(evt.item.src, evt.item.id);
                }
            }

            function loadManifestComp(evt) {
                resolve(evt.target);
            }

            function loadManifestError(e: createjs.ErrorEvent) {
                // reject(e.title + ":" + e.data['src']);
                // reject(e.title);
            }
        });

        const timeoutFunc = new Promise((_resolve, reject) => {
            setTimeout(() => reject('TIMEOUT:ManifestLoader'), this.timeout);
        });

        return new Promise((resolve, reject) => {
            Promise.race([
                loadFunc,
                timeoutFunc
            ]).then(value => {
                resolve(<createjs.ManifestLoader>value);

                
            }).catch(reason => {

            })
        })
    }
}
